import React from 'react';
import './SalesEnquiries.css';

const SalesEnquiries = () => {
  // Top Stats Data (6 cards)
   const statsData = [
  {
    id: 'stat-sourcing',
    label: 'SOURCING',
    value: '4',
    sub: '₹11,95,000'
  },
  {
    id: 'stat-enquiry',
    label: 'ENQUIRY',
    value: '2',
    sub: '₹2,75,000'
  },
  {
    id: 'stat-quote',
    label: 'QUOTE',
    value: '1',
    sub: '₹9,20,000'
  },
  {
    id: 'stat-approval',
    label: 'APPROVAL',
    value: '1',
    sub: '₹9,20,000'
  },
  {
    id: 'stat-po',
    label: 'PO',
    value: '1',
    sub: '₹9,20,000'
  },
  {
    id: 'stat-execution',
    label: 'EXECUTION',
    value: '1',
    sub: '₹9,20,000'
  },
  {
    id: 'stat-payment',
    label: 'PAYMENT',
    value: '2',
    sub: '₹9,20,000'
  },
  {
    id: 'stat-pending',
    label: 'PENDING',
    value: '3',
    sub: '₹5,35,000 pending'
  }
];
  // Pipeline Stages Data
  const pipelineStages = ['Sourcing', 'Enquiry', 'Quote', 'Approval', 'PO', 'Execution', 'Payment'];
  const pipelineCounts = [4, 2, 1, 1, 1, 1, 2];
  const pipelineValues = ['₹11,95,000', '₹2,75,000', '₹9,20,000', '₹9,20,000', '₹9,20,000', '₹9,20,000', '₹9,20,000'];

  // Enquiry Status Cards Data (as per new image)
  const enquiryStatusCards = [
    { name: 'Pending Quote', count: 1, value: '₹0', color: 'pending' },
    { name: 'Quote Submitted', count: 1, value: '₹2,75,000', color: 'submitted' },
    { name: 'Approved', count: 1, value: '₹9,20,000', color: 'approved' },
    { name: 'Rejected', count: 0, value: '₹0', color: 'rejected' },
    { name: 'Revision', count: 0, value: '₹0', color: 'revision' },
  ];

  // Project Status Cards Data (as per new image)
  const projectStatusCards = [
    { name: 'Initiated', count: 0, value: '₹0', color: 'initiated' },
    { name: 'In Progress', count: 1, value: '₹9,20,000', color: 'progress' },
    { name: 'Completed', count: 0, value: '₹0', color: 'completed' },
  ];

  // Recent Enquiries Data (3 rows with new ENQ-59AHL)
  const recentEnquiriesData = [
    { id: 'ENQ-X1Y2Z', client: 'Acme Industries', quote: '₹9,20,000', status: 'Approved', clientStatus: 'Accepted', owner: 'Priya (Exec)' },
    { id: 'ENQ-M3N4O', client: 'Acme Industries', quote: '₹2,75,000', status: 'Quote Submitted', clientStatus: 'Negotiation', owner: 'Karan (Exec)' },
    { id: 'ENQ-59AHL', client: 'Orbit Logistics', quote: '—', status: 'Pending Quote', clientStatus: '—', owner: 'Priya (Exec)' },
  ];

  return (
    <div className="vks-dashboard-container">
      <div className="vks-dashboard-wrapper">
        {/* Header Section */}
        {/* <div className="vks-header-area">
          <h1 className="vks-title-main">Dashboard</h1>
          <p className="vks-title-sub">Complete pipeline overview — sourcing to payment.</p>
        </div> */}

        {/* Top Stats Grid - 6 cards */}
        <div className="vks-top-stats-grid">
          {statsData.map((stat) => (
            <div key={stat.id} className="vks-top-stat-card">
              <div className="vks-top-stat-label">{stat.label}</div>
              <div className="vks-top-stat-value">{stat.value}</div>
              {stat.sub && <div className="vks-top-stat-sub">{stat.sub}</div>}
            </div>
          ))}
        </div>

        {/* Pipeline Flow Section */}
        <div className="vks-pipeline-area">
          <h2 className="vks-section-heading">Pipeline Flow</h2>
          <div className="vks-pipeline-track">
            {pipelineStages.map((stage, idx) => (
              <React.Fragment key={idx}>
                <div className="vks-pipeline-node">
                  <div className="vks-pipeline-name">{stage}</div>
                  <div className="vks-pipeline-counter">{pipelineCounts[idx]}</div>
                  <div className="vks-pipeline-amount">{pipelineValues[idx]}</div>
                </div>
                {idx < pipelineStages.length - 1 && (
                  <div className="vks-pipeline-connector">→</div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Two Column Layout: Enquiry Status + Project Status */}
        <div className="vks-two-column-layout">
          {/* Enquiry Status Cards Section */}
          <div className="vks-enquiry-status-area">
            <h2 className="vks-section-heading">Enquiry status</h2>
            <div className="vks-status-cards-grid">
              {enquiryStatusCards.map((card, idx) => (
                <div key={idx} className={`vks-status-card vks-status-card-${card.color}`}>
                  <div className="vks-status-card-name">{card.name}</div>
                  <div className="vks-status-card-count">{card.count}</div>
                  <div className="vks-status-card-value">{card.value}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Project Status Cards Section */}
          <div className="vks-project-status-area">
            <h2 className="vks-section-heading">Project status</h2>
            <div className="vks-status-cards-grid">
              {projectStatusCards.map((card, idx) => (
                <div key={idx} className={`vks-status-card vks-status-card-${card.color}`}>
                  <div className="vks-status-card-name">{card.name}</div>
                  <div className="vks-status-card-count">{card.count}</div>
                  <div className="vks-status-card-value">{card.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Recent Enquiries Section with View All link */}
        <div className="vks-recent-area">
          <div className="vks-recent-header">
            <h2 className="vks-section-heading">Recent enquiries</h2>
            <a href="#" className="vks-view-all-link">View all →</a>
          </div>
          
          <div className="vks-table-wrapper">
            <table className="vks-data-table">
              <thead>
                <tr className="vks-table-header-row">
                  <th className="vks-table-header">ID</th>
                  <th className="vks-table-header">CLIENT</th>
                  <th className="vks-table-header">QUOTE</th>
                  <th className="vks-table-header">STATUS</th>
                  <th className="vks-table-header">CLIENT STATUS</th>
                  <th className="vks-table-header">OWNER</th>
                </tr>
              </thead>
              <tbody>
                {recentEnquiriesData.map((row, idx) => (
                  <tr key={idx} className="vks-table-row">
                    <td className="vks-table-cell">{row.id}</td>
                    <td className="vks-table-cell">{row.client}</td>
                    <td className="vks-table-cell">{row.quote}</td>
                    <td className="vks-table-cell">
                      <span className={`vks-status-badge vks-badge-${row.status.toLowerCase().replace(/\s+/g, '-')}`}>
                        {row.status}
                      </span>
                    </td>
                    <td className="vks-table-cell">
                      {row.clientStatus !== '—' ? (
                        <span className={`vks-client-badge vks-client-${row.clientStatus.toLowerCase()}`}>
                          {row.clientStatus}
                        </span>
                      ) : (
                        <span className="vks-client-badge vks-client-empty">—</span>
                      )}
                    </td>
                    <td className="vks-table-cell">{row.owner}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesEnquiries;